// Resolve which value_types a chart renders.
// Multi-select: the selected subset, or all when nothing is selected.
// FU-i: clamp to the available set — a stale URL vt (fact switch, retired vt) must never
// produce an empty chart or flip series-key namespaces under a baseline. URL state is user
// input: graceful fallback is the legitimate exception to no-silent-fallbacks.
export function resolveEffectiveVts(selected: string[], all: string[]): string[] {
  const valid = selected.filter((v) => all.includes(v))
  return valid.length > 0 ? valid : all
}
